import 'babel-polyfill';
import React from 'react';
import ReactDOM from 'react-dom';
import App from './App/App';
import { Provider } from 'react-redux';

import configureStore from './redux/store.js';
import rootSaga from './redux/sagas';
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';
import 'react-quill/dist/quill.snow.css';
import ScrollToTop from './common/ScrollToTop';
import history from './common/history';
import { Router } from 'react-router';



// Sentry.io integration
import * as Sentry from '@sentry/browser';
if (process.env.NODE_ENV === 'development') {
    Sentry.init({
        environment: 'development',
        dsn: "https://ed1e7d54bddf436ab6cb7d031ff3e07d@sentry.io/1329672"
    });
} else {
    Sentry.init({
        environment: 'production',
        dsn: "https://ed1e7d54bddf436ab6cb7d031ff3e07d@sentry.io/1329672"
    });
}

const theme = createMuiTheme({
    palette: {
        type: 'dark',
        primary: {
            main: '#b2d973',

        },
        secondary: {
            main: '#b2d973',
        },
    },
    typography: {
        useNextVariants: true,
        fontSize: 14,
        htmlFontSize: 12,
        fontFamily: [
            'proxima_novaregular',
        ].join(','),
    },
    overrides:{
        MuiInput: {
            root: {
                color: '#b2b2b2',
                '&:hover:not($disabled)': {
                    color: '#cccccc',
                },
            },
            underline: {
                '&:before': {
                    borderBottom: "1px solid rgba(13,26,13,1.0)",
                },
                '&:after': {
                    color: "#cccccc",
                    borderBottom: "1px solid rgb(193, 224, 143)",
                },
                '&:hover:not($disabled):not($focused):not($error):before': {
                    borderBottom: "1px solid rgba(39, 49, 39, 0.8)",
                },
            },
        },
        MuiFormLabel: {
            root: {
                color: '#b2b2b2',
                fontWeight: 'normal',
                paddingBottom: "1px",
            },
        },
        MuiPaper: {
            root: {
                backgroundColor: "none",
            },
        },
        MuiPopover: {
            paper: {
                backgroundColor: "#000000",
            },
        },
        MuiIconButton: {
            root: {
                width: "30px",
                height: "30px",
            },
        },
        MuiCheckbox: {
            root: {
                color: '#b2b2b2',
            },
            colorSecondary: {

            }
        },
        MuiFormControl: {
            root: {
                verticalAlign: 'none'
            }
        },
        MuiFormControlLabel: {
            root: {
                marginLeft: "0",
                marginBottom: "0",
            },
        },
        MuiFormGroup: {
            root: {
                display: "inline-flex",
                flexDirection: "row",
            }
        },
        MuiTypography: {
            root: {
                color: '#b2b2b2',
            },
            body1: {
                color: '#b2b2b2',
            }
        },
        MuiDialog: {
            paper: {
                backgroundColor: "#000",
            },
        },
        MuiPickersToolbar: {
            toolbar: {
                backgroundColor: "#000",
            },
        },
        MuiBadge: {
            badge: {
                top: "-5px",
                height: "14px",
                right: "-5px",
                width: "14px",
            },
            colorPrimary: {
                color: "white",
                backgroundColor: "red",
                fontWeight: "bolder",
            },
        },
    },
});

const store = configureStore(window.__INITIAL_STATE__);
store.runSaga(rootSaga);

ReactDOM.render(
    <Provider store = {store}>
        <Router history= {history}>
            <ScrollToTop>
                <MuiThemeProvider theme={theme}>
                    <App />
                </MuiThemeProvider>
            </ScrollToTop>
        </Router>
    </Provider>,
  document.getElementById('root')
);
//registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js